module.exports = __webpack_public_path__ + "img/20190912105241949.cee8dfb1.jpg";